module.exports = __webpack_public_path__ + "static/media/git_atencao_domiciliar.360834c7.gif";